/*
 * TranscriptsFilter Messages
 *
 * This contains all the text for the TranscriptsFilter component.
 */
import { defineMessages } from 'react-intl';

const messages = {
  name: {
    id: 'PARTICIPANTS.name',
    defaultMessage: 'Name',
  },
  type: {
    id: 'PARTICIPANTS.type',
    defaultMessage: 'Type',
  },
  company: {
    id: 'PARTICIPANTS.company',
    defaultMessage: 'Company',
  },
  phone: {
    id: 'PARTICIPANTS.phone',
    defaultMessage: 'Phone',
  },
  country: {
    id: 'PARTICIPANTS.country',
    defaultMessage: 'Country',
  },
};

export default defineMessages(messages);



// WEBPACK FOOTER //
// ./components/organisms/ParticipantsTable/messages.js